import { ValidationFunction } from './Validator.interface'

const MIN_NUMBER_ERROR_TEMPLATE = (min: number) => `Must be greater or equal than ${min}.`
export const MinNumberValidator =
  (minValue: number | undefined, errorTemplate = MIN_NUMBER_ERROR_TEMPLATE): ValidationFunction =>
  (value) => {
    if (typeof minValue === 'undefined') {
      return ''
    }

    if (typeof value === 'undefined') {
      return ''
    }

    const parsedNumber: number = typeof value === 'number' ? value : parseFloat(value.toString())

    if (parsedNumber < minValue) {
      return errorTemplate(minValue)
    }

    return ''
  }
